/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable no-undef */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  Avatar_16,
  Avatar_02,
  Avatar_05,
  Avatar_09,
  Avatar_10,
} from "../../../Routes/ImagePath/index";

import { Link } from "react-router-dom";
import Select from "react-select";
import { useTranslation } from "react-i18next";

import React, { useState, useEffect } from "react";

import AuthUser from "../../AuthUser";

import { toast, ToastContainer } from "react-toastify";

import Spinner from "../../Spinner";

import Swal from "sweetalert2";

const AnexosDoColaboradorModal = ({ utilizador }) => {
  
  const { t } = useTranslation();

  // eslint-disable-next-line no-unused-vars
  const {
    http,
    url_root,
    user,
    user_permissoes,
    verificarPermissao,
    getMissao,
  } = AuthUser();

  const [arquivos, setArquivos] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await verArquivos();
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [utilizador]);

  const verArquivos = async () => {
    try {
      setLoading(true); // Set loading to true when the request starts

      const formData = new FormData();
      formData.append("colaborador_id", utilizador?.id);

      const response = await http.post("/utilizador/arquivos", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setArquivos(response.data.arquivos);

      setLoading(false);
    } finally {
      setLoading(false); // Set loading to false when the request is complete (either success or error)
    }
  };

  return (
    <>
      {/* Add Task Modal */}
      <div
        id="anexos_do_colaborador_modal"
        className="modal custom-modal fade"
        role="dialog"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" onClick={()=>verArquivos()}><i className="fa fa-recycle"></i>{loading ? <i className="fa fa-spinner fa-spin me-2"></i>:t(" Anexos do colaborador - "+utilizador?.name)}</h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                id="closeButton30"
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              <ul className="list-unstyled">
                {arquivos?.map((arquivo, index) => {
                  const dataEmissao = arquivo?.dataEmissao
                    ? new Date(arquivo.dataEmissao)
                    : null;
                  const dataExpira = arquivo?.dataExpira
                    ? new Date(arquivo.dataExpira)
                    : null;

                  const hoje = new Date();
                  const diasRestantes =
                    dataExpira != null
                      ? Math.ceil((dataExpira - hoje) / (1000 * 60 * 60 * 24))
                      : null;

                  return (
                    <li
                      key={index}
                      className="d-flex justify-content-between align-items-center border-bottom py-2"
                    >
                      <div
                        className="d-flex align-items-center"
                        style={{ flex: 1 }}
                      >
                        <img
                          src={`${url_root}/storage/uploads/icons/${arquivo?.file_icon}`}
                          alt="icon"
                          width={36}
                          height={36}
                          className="me-3"
                        />

                        <div>
                          <div className="fw-semibold">
                            {arquivo?.tipo_anexo?.designacao}
                          </div>
                          <div>
                            <a
                              className="text-primary"
                              href={`${url_root}/api/ler_anexo/${arquivo?.ficheiro}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {arquivo?.descricao}
                            </a>
                          </div>
                          <small className="text-muted d-block">
                            {arquivo?.created_at
                              ? new Date(
                                  arquivo?.created_at
                                ).toLocaleDateString("pt-BR")
                              : ""}
                            {" • "}
                            {t("Size")}: {arquivo?.tamanho}Mb
                          </small>
                          {dataEmissao && (
                            <small className="text-muted d-block">
                              📅 Emissão:{" "}
                              {dataEmissao.toLocaleDateString("pt-BR")}
                            </small>
                          )}
                          {dataExpira && (
                            <small className="text-muted d-block">
                              ⏳ Expira:{" "}
                              {dataExpira.toLocaleDateString("pt-BR")}{" "}
                              {diasRestantes != null &&
                                (diasRestantes >= 0
                                  ? `(${diasRestantes} dias restantes)`
                                  : `(${Math.abs(
                                      diasRestantes
                                    )} ⏳ dias expirados)`)}
                            </small>
                          )}
                        </div>
                      </div>
                     
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Task Modal */}
    </>
  );
};

export default AnexosDoColaboradorModal;
